import { Package } from 'lucide-react'
import clsx from 'clsx'

export interface VanStockToggleProps {
  enabled: boolean
  onChange: (enabled: boolean) => void
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export function VanStockToggle({ enabled, onChange, onClick }: VanStockToggleProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e)
    onChange(!enabled)
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={enabled}
      className="inline-flex items-center gap-2 py-1 cursor-pointer select-none"
    >
      <Package className={clsx('w-3.5 h-3.5', enabled ? 'text-violet-600' : 'text-gray-400')} />
      <span className={clsx('text-[11px] font-semibold', enabled ? 'text-violet-700' : 'text-gray-500')}>
        Van stock
      </span>
      {/* iOS-style switch track */}
      <span
        className={clsx(
          'relative inline-flex h-5 w-9 shrink-0 rounded-full transition-colors duration-200 ease-in-out',
          enabled ? 'bg-violet-600' : 'bg-gray-300'
        )}
      >
        {/* Sliding knob */}
        <span
          className={clsx(
            'pointer-events-none absolute top-0.5 left-0.5 inline-block h-4 w-4 rounded-full bg-white shadow transition-transform duration-200 ease-in-out',
            enabled ? 'translate-x-4' : 'translate-x-0'
          )}
        />
      </span>
    </button>
  )
}
